import { LoadingView } from '../../components/LoadingView'
import { useGetObjects } from '../../hooks/useGetObjects';
import { AutomationObjectsFlexGridView } from '../../automationObjects/components/Grid/AutomationObjectsFlexGridView';


const ObjectsView = () => {
    const { objects, error, isLoading, isSuccess } = useGetObjects();
    return (
        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                <AutomationObjectsFlexGridView items={objects ?? []}></AutomationObjectsFlexGridView>
        </LoadingView>
    )
}

export default ObjectsView



